
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/partners/mssp/HeroSection";
import TransformationIntroSection from "@/components/partners/mssp/TransformationIntroSection";
import SubscriptionBannerSection from "@/components/partners/mssp/SubscriptionBannerSection";
import RuleBasedToAgenticSection from "@/components/partners/mssp/RuleBasedToAgenticSection";
import AutomationToPartnershipSection from "@/components/partners/mssp/AutomationToPartnershipSection";
import PodRevolutionSection from "@/components/partners/mssp/PodRevolutionSection";
import WhyMSSPsChooseSection from "@/components/partners/mssp/WhyMSSPsChooseSection";
import FinalCTASection from "@/components/partners/mssp/FinalCTASection";

const MSSP = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1">
        <HeroSection />
        <TransformationIntroSection />
        <SubscriptionBannerSection />
        <RuleBasedToAgenticSection />
        <AutomationToPartnershipSection />
        <PodRevolutionSection />
        <WhyMSSPsChooseSection />
        <FinalCTASection />
      </main>

      <Footer />
    </div>
  );
};

export default MSSP;
